function setRem() {
  const html = document.documentElement;
  const designWidth = 750; // 设计稿宽度，根据实际情况调整
  const rem = (html.clientWidth / designWidth) * 10; // 设置1rem为设计稿宽度的十分之一（例如：37.5px）
  html.style.fontSize = `${rem}px`;
}
 
window.onresize = setRem; // 窗口大小改变时重新设置rem基准值
setRem(); // 页面加载时也设置一次rem基准值